import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, BookOpen, Settings, BadgeCheck, User } from "lucide-react";

const navItems = [
    { path: "/", icon: <Home size={22} />, label: "Home" },
    { path: "/course", icon: <BookOpen size={22} />, label: "Courses" },
    { path: "/equipments", icon: <Settings size={22} />, label: "Equipments" },
    { path: "/admission-form", icon: <BadgeCheck size={22} />, label: "Admission" },
    { path: "/my-account", icon: <User size={22} />, label: "Account" },
];

const MobileBottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="ecommerce-theme2-mobile-bottom-nav">
            {navItems.map(({ path, icon, label }) => {
                const isActive = location.pathname === path;
                return (
                    <div
                        key={path}
                        className={`ecommerce-theme2-mobile-nav-item ${isActive ? "active" : ""
                            }`}
                        onClick={() => navigate(path)}
                    >
                        {icon}
                        {isActive && <span>{label}</span>}
                    </div>
                );
            })}
        </div>
    );
};

export default MobileBottomNav;
